<template>
	<div class="modal-dialog" style="max-width: 50vw;">
		<div class="modal fade" id="investor_premium_upgrade_modal">
			<div class="modal-dialog modal-lg">
				<div class="modal-content">
					<div class="modal-header d-block">
						<div class="mb-3"><b>Premium Upgrade</b></div>
						<div class="mb-3"><span>Thank you for supporting the growth of Malaysian SMEs.</span></div>
						<div class="mb-3"><span>As a valued investor, we are pleased to invite you to join our Premium Investor program.</span></div>
						<hr/>
					</div>
					<div v-if="!premiumUpgradeCreated" class="modal-body" style="padding: 0px 25px !important;">
						<div class="mb-3">
							<span>To proceed, please provide the following information.</span>
						</div>
						<div class="row">
							<div class="col-sm-12 col-12">
								<label>I am a Malaysian Tax Resident *
									<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
             							title="Non-Malaysian tax residents are subject to withholding tax as per the regulations of the Inland Revenue Board of Malaysia (IRBM)">
										<i class="fa fa-question-circle"></i>
									</a>
								</label>
								<div class="form-group">
									<input type="radio" id="inv_malaysian_tax_resident_true" name="inv_malaysian_tax_resident" value="1" v-model="form.inv_malaysian_tax_resident">
									<label for="inv_malaysian_tax_resident_true">Yes</label>
									<input class="ml-3" type="radio" id="inv_malaysian_tax_resident_false" name="inv_malaysian_tax_resident" value="0" v-model="form.inv_malaysian_tax_resident">
									<label for="inv_malaysian_tax_resident_false">No</label>
								</div>
							</div>
							<div v-if="form.inv_malaysian_tax_resident == 0" class="col-sm-12 col-12">
								<div class="form-group" :class="{' has-danger' : $v.form.inv_country_tax_resident.$error && form.inv_malaysian_tax_resident == 0}">
									<label>Non-Malaysian tax residents, please specify your country of tax residence *</label>
									<div class="mb-1">
										<select name="inv_country_tax_resident" v-model="form.inv_country_tax_resident"
											@click="$v.form.inv_country_tax_resident.$touch()"
											class="form-control">
											<option value="">Select Country</option>
											<option :value="country.value" v-for="(country) in filteredCountries" :key="country">
												{{ country.name }}
											</option>
										</select>
									</div>
									<div v-if="$v.form.inv_country_tax_resident.$error">
										<div class="small text-danger" v-if="!$v.form.inv_country_tax_resident.required">
											Please provide Country of Tax Residence
										</div>
									</div>
								</div>
							</div>
							<div v-if="form.inv_malaysian_tax_resident == 0" class="col-sm-12 col-12">
								<div class="form-group" :class="{' has-danger' : $v.form.inv_non_malaysian_income_tax.$error && form.inv_malaysian_tax_resident == 0}">
									<label>Income Tax Number *</label>
									<div class="mb-1">
										<input type="text"
												@blur="$v.form.inv_non_malaysian_income_tax.$touch()"
												v-model="form.inv_non_malaysian_income_tax"
												name="inv_non_malaysian_income_tax"
												class="form-control"/>
									</div>
									<div v-if="$v.form.inv_non_malaysian_income_tax.$error">
										<div class="small text-danger" v-if="!$v.form.inv_non_malaysian_income_tax.required">
											Please provide Income Tax Number
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-12">
								<!-- Annual Income amount -->
								<div class="form-group" :class="{' has-danger' : $v.form.inv_annual_income.$error}">
									<label>Estimated Annual Income *
										<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
             								title="E.g. Salary, Bonus, Pension etc.">
											<i class="fa fa-question-circle"></i>
										</a>
									</label>
									<div class="input-group mb-1">
										<div class="input-group-prepend">
											<div class="input-group-text" style="height: min-content; font-size: 0.8em">
												{{ default_currency }}
											</div>
										</div>
										<select name="inv_annual_income" v-model="form.inv_annual_income"
											@click="$v.form.inv_annual_income.$touch()"
											class="form-control">
											<option value="">Select Estimated Annual Income</option>
											<option value="below_50k">50,000 & below</option>
											<option value="50k_100k">50,000 - 100,000</option>
											<option value="100k_250k">100,000 - 250,000</option>
											<option value="250k_500k">250,000 - 500,000</option>
											<option value="500k_1m">500,000 - 1,000,000</option>
											<option value="1m_3m">1,000,000 - 3,000,000</option>
											<option value="above_3m">Above 3,000,000</option>
										</select>
									</div>
									<div v-if="$v.form.inv_annual_income.$error" dusk="inv_annual_income_error">
										<div class="small text-danger" v-if="!$v.form.inv_annual_income.required">
											Please provide Estimated Annual Income
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-12">
								<div class="form-group" :class="{' has-danger' : $v.form.inv_total_liquid_assets.$error}">
									<label>Estimate value of Liquid Assets *
										<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
             								title="E.g. Stocks, Bonds, Unit Trust, Crypto Currency, Cash etc.">
											<i class="fa fa-question-circle"></i>
										</a>
									</label>
									<div class="input-group mb-1">
										<div class="input-group-prepend">
											<div class="input-group-text" style="height: min-content; font-size: 0.8em">
												{{ default_currency }}
											</div>
										</div>
										<select name="inv_total_liquid_assets" v-model="form.inv_total_liquid_assets"
											@click="$v.form.inv_total_liquid_assets.$touch()"
											class="form-control">
											<option value="">Select Estimate value of Liquid Assets</option>
											<option value="below_50k">50,000 & below</option>
											<option value="50k_100k">50,000 - 100,000</option>
											<option value="100k_250k">100,000 - 250,000</option>
											<option value="250k_500k">250,000 - 500,000</option>
											<option value="500k_1m">500,000 - 1,000,000</option>
											<option value="1m_3m">1,000,000 - 3,000,000</option>
											<option value="above_3m">Above 3,000,000</option>
										</select>
									</div>
									<div v-if="$v.form.inv_total_liquid_assets.$error" dusk="asset_amount_error">
										<div class="small text-danger" v-if="!$v.form.inv_total_liquid_assets.required">
											Please provide Estimate value of Liquid Assets
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-12">
								<div class="form-group" :class="{' has-danger' : $v.form.inv_other_assets_amount.$error}">
									<label>Estimate value of Other Assets *
										<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
             								title="E.g. Vehicles, Property, Land etc.">
											<i class="fa fa-question-circle"></i>
										</a>
									</label>
									<div class="input-group mb-1">
										<div class="input-group-prepend">
											<div class="input-group-text" style="height: min-content; font-size: 0.8em">
												{{ default_currency }}
											</div>
										</div>
										<select name="inv_other_assets_amount" v-model="form.inv_other_assets_amount"
											@click="$v.form.inv_other_assets_amount.$touch()"
											class="form-control">
											<option value="">Select Estimate value of Other Assets</option>
											<option value="below_50k">50,000 & below</option>
											<option value="50k_100k">50,000 - 100,000</option>
											<option value="100k_250k">100,000 - 250,000</option>
											<option value="250k_500k">250,000 - 500,000</option>
											<option value="500k_1m">500,000 - 1,000,000</option>
											<option value="1m_3m">1,000,000 - 3,000,000</option>
											<option value="above_3m">Above 3,000,000</option>
										</select>
									</div>
									<div v-if="$v.form.inv_other_assets_amount.$error" dusk="other_asset_error">
										<div class="small text-danger" v-if="!$v.form.inv_other_assets_amount.required">
											Please provide Estimate value of Other Assets
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-12">
								<div class="form-group" :class="{' has-danger' : $v.form.inv_total_liabilities_amount.$error}">
									<label>Estimate value of Total Liabilities *
										<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
             								title="E.g. Loans, Mortgage etc.">
											<i class="fa fa-question-circle"></i>
										</a>
									</label>
									<div class="input-group mb-1">
										<div class="input-group-prepend">
											<div class="input-group-text" style="height: min-content; font-size: 0.8em">
												{{ default_currency }}
											</div>
										</div>
										<select name="inv_total_liabilities_amount" v-model="form.inv_total_liabilities_amount"
											@click="$v.form.inv_total_liabilities_amount.$touch()"
											class="form-control">
											<option value="">Select Estimate value of Total Liabilities</option>
											<option value="below_50k">50,000 & below</option>
											<option value="50k_100k">50,000 - 100,000</option>
											<option value="100k_250k">100,000 - 250,000</option>
											<option value="250k_500k">250,000 - 500,000</option>
											<option value="500k_1m">500,000 - 1,000,000</option>
											<option value="1m_3m">1,000,000 - 3,000,000</option>
											<option value="above_3m">Above 3,000,000</option>
										</select>
									</div>
									<div v-if="$v.form.inv_total_liabilities_amount.$error" dusk="total_liabilities_error">
										<div class="small text-danger" v-if="!$v.form.inv_total_liabilities_amount.required">
											Please provide Estimate value of Total Liabilities
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-12">
								<div class="form-group" :class="{' has-danger' : $v.form.inv_net_worth.$error}">
									<label>Estimate of your Net Worth *
										<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
             								title="Total Assets - Total Liabilities">
											<i class="fa fa-question-circle"></i>
										</a>
									</label>
									<div class="input-group mb-1">
										<div class="input-group-prepend">
											<div class="input-group-text" style="height: min-content; font-size: 0.8em">
												{{ default_currency }}
											</div>
										</div>
										<select name="inv_net_worth" v-model="form.inv_net_worth"
											@click="$v.form.inv_net_worth.$touch()"
											class="form-control">
											<option value="">Select Estimate of your Net Worth</option>
											<option value="below_50k">50,000 & below</option>
											<option value="50k_100k">50,000 - 100,000</option>
											<option value="100k_250k">100,000 - 250,000</option>
											<option value="250k_500k">250,000 - 500,000</option>
											<option value="500k_1m">500,000 - 1,000,000</option>
											<option value="1m_3m">1,000,000 - 3,000,000</option>
											<option value="above_3m">Above 3,000,000</option>
										</select>
									</div>
									<div v-if="$v.form.inv_net_worth.$error">
										<div class="small text-danger" v-if="!$v.form.inv_net_worth.required">
											Please provide Estimate of your Net Worth
										</div>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-12">
								<div class="form-group" :class="{' has-danger' : $v.form.inv_source_of_funds.$error}">
									<label>Source of Funds/Wealth *
										<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
             								title="Origin of how you have acquired the majority of your financial assets">
											<i class="fa fa-question-circle"></i>
										</a>
									</label>
									<div class="mb-1">
										<select name="inv_source_of_funds" v-model="form.inv_source_of_funds"
											@click="$v.form.inv_source_of_funds.$touch()"
											class="form-control">
											<option value="">Select Source of Funds/Wealth</option>
											<option value="salary_and_bonuses">Salary + Bonuses</option>
											<option value="pension">Pension</option>
											<option value="savings_or_investment">Savings / Investment</option>
											<option value="property_or_asset_sale">Property / Asset Sale</option>
											<option value="company_profits_or_sale">Company Profits / Sale</option>
											<option value="inheritance_or_gift">Inheritance / Gift</option>
										</select>
									</div>
									<div v-if="$v.form.inv_source_of_funds.$error">
										<div class="small text-danger" v-if="!$v.form.inv_source_of_funds.required">
											Please provide Source of Funds/Wealth
										</div>
									</div>
								</div>
							</div>						
							<div class="col-sm-12 col-12">
								<label>Are you a Sophisticated Investor? *
									<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
             							title="You qualify as a Sophisticated Investor if you meet any of the following criteria :
										<br/>(a) Your total net personal assets exceed RM3million
										<br/>(b) Your gross annual income is greater than RM300,000
										<br/>(c) Your combined gross annual income exceeds RM400,000
										<br/>(d) Your total net personal investment portfolio (e.g. EPF, Unit Trust etc.) in any capital market is more than RM1million">
										<i class="fa fa-question-circle"></i>
									</a>
								</label>
								<div class="form-group">
									<input type="radio" id="inv_is_sophisticated_investor_true" name="inv_is_sophisticated_investor" value="1" v-model="form.inv_is_sophisticated_investor">
									<label for="inv_is_sophisticated_investor_true">Yes</label>
									<input class="ml-3" type="radio" id="inv_is_sophisticated_investor_false" name="inv_is_sophisticated_investor" value="0" v-model="form.inv_is_sophisticated_investor">
									<label for="inv_is_sophisticated_investor_false">No</label>
								</div>
							</div>
						</div>
						<hr/>
						<h5>Please supplement the declaration above with the following supporting documents</h5>
						<small class="text-muted">Only accepts: PDF, Images</small>
						<div class="form-group mt-2" :class="{' has-danger' : $v.form.inv_income_slip.$error}">
							<label>3 Months Latest Bank statement/Income Slip/Income Tax Form *
								<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
									title="Bank Statement of Primary/Main account, Income Slip, Income Tax Form">
									<i class="fa fa-question-circle"></i>
								</a>
							</label>
							<input type="file" :accept="globalFileAccept" class="form-control mb-1"
									v-on:change="incomeSlipFileChange"
									ref="income_slip_file_input"
									id="income_slip_file_input"
									name="income_slip_file_input"
									multiple/>
							<div v-if="$v.form.inv_income_slip.$error" dusk="income_slip_error">
								<div class="small text-danger" v-if="!$v.form.inv_income_slip.required">
									Please upload 3 Months Latest Bank statement/Income Slip/Income Tax Form
								</div>
							</div>
						</div>
						<div class="form-group mt-2" :class="{' has-danger' : $v.form.inv_personal_assets.$error}">
							<label>Personal Assets *
								<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
									title="E.g. Stocks, Bonds, Unit Trust, Crypto Currency, Cash etc.">
									<i class="fa fa-question-circle"></i>
								</a>
							</label>
							<input type="file" :accept="globalFileAccept" class="form-control mb-1"
									v-on:change="personalAssetsFileChange"
									ref="personal_assets_file_input"
									id="personal_assets_file_input"
									name="personal_assets_file_input"
									multiple/>
							<div v-if="$v.form.inv_personal_assets.$error">
								<div class="small text-danger" v-if="!$v.form.inv_personal_assets.required">
									Please upload Personal Assets
								</div>
							</div>
						</div>
						<div class="form-group mt-2">
							<label>Additional Documents
								<a href="#" class="ml-1" data-toggle="tooltip" data-placement="right" data-html="true"
									title="Supporting documents of Source of Funds/Liabilities<br/>E.g. EA Form, Pension Slip, SPA, etc.">
									<i class="fa fa-question-circle"></i>
								</a>
							</label>
							<input type="file" :accept="globalFileAccept" class="form-control mb-1"
									v-on:change="additionalDocumentsFileChange"
									ref="additional_documents_file_input"
									id="additional_documents_file_input"
									name="additional_documents_file_input"
									multiple/>
						</div>
						<div class="form-group mt-4">
							<div class="form-check text-left">
								<label class="form-check-label">
									<input class="form-check-input" 
										type="checkbox" 
										name="inv_agree_declaration" 
										v-model="form.inv_agree_declaration"
										@change="$v.form.inv_agree_declaration.$touch()">
									<span class="form-check-sign"></span>
									I hereby declare that the above information is true, correct, and complete to the best of my knowledge and belief, and that I understand any false statements may result in legal consequences.
								</label>
								<div v-if="$v.form.inv_agree_declaration.$error">
									<div class="small text-danger" v-if="!$v.form.inv_agree_declaration.mustBeTrue">
										Please agree to this declaration
									</div>
								</div>
							</div>
						</div>
						<div class="form-group mt-5 mb-5 text-right" dusk="submit-upgrade">
							<button :disabled="loading"
									class="btn btn-secondary" data-dismiss="modal">Cancel</button>
							<button class="btn btn-info"
									:disabled="loading"
									v-on:click="submit">
								Submit
							</button>
						</div>
					</div>
					<div v-else class="modal-body">
						<div class="alert alert-info">
							Your premium upgrade application is pending for approval.
						</div>
	
						<div class="form-group mt-5 text-right" dusk="submit-upgrade">
							<button :disabled="loading"
									class="btn btn-secondary" data-dismiss="modal">Close</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { required, minValue, maxValue, minLength, numeric, email, between, url, helpers, requiredIf, sameAs } from 'vuelidate/lib/validators'
import FileValidator from "../../mixins/FileValidator";
import InvalidKeysForNumbers from "../../mixins/InvalidKeysForNumbers";
import UserService from "../../services/UserService";
import store from './../../stores/index';

export default {
	name: "InvestorPremiumUpgradeModal",
	mixins: [FileValidator, InvalidKeysForNumbers],

	data () {
		return {
			loading: false,
			default_currency: 'RM',
			form: {
				inv_malaysian_tax_resident: 1,
				inv_country_tax_resident: '',
				inv_non_malaysian_income_tax: null,
				inv_annual_income: '',
				inv_total_liquid_assets: '',
				inv_other_assets_amount: '',
				inv_total_liabilities_amount: '',
				inv_net_worth: '',
				inv_source_of_funds: '',
				inv_is_sophisticated_investor: 0,
	
				//files
				inv_income_slip: [],
				inv_personal_assets: [],
				inv_additional_documents: [],
				
				inv_agree_declaration: false,
			},
			countries: [],
		}
	},
	mounted () {
		this.$nextTick(() => {
			$('[data-toggle="tooltip"]').tooltip();
		})
		UserService.getInvestorRegistrationConstants().then((res) => {
			if (res.data.success) {
				if (res.data.countries){
					this.countries = res.data.countries;
				}
			}
		})
	},
	validations () {
		return {
			form: {
				inv_malaysian_tax_resident: { required },
				inv_country_tax_resident: { 
					required: requiredIf((form) => {
						return (parseInt(form.inv_malaysian_tax_resident) === 0);
					})
				},
				inv_non_malaysian_income_tax: { 
					required: requiredIf((form) => {
						return (parseInt(form.inv_malaysian_tax_resident) === 0);
					})
				},
				inv_annual_income: { required },
				inv_total_liquid_assets: { required },
				inv_other_assets_amount:  { required },
				inv_total_liabilities_amount:  { required },
				inv_net_worth:  { required },
				inv_source_of_funds:  { required },
				inv_is_sophisticated_investor:  { required },

				//file
				inv_income_slip: { required },
				inv_personal_assets: { required },

				inv_agree_declaration: {
					mustBeTrue: value => value === true
				}
			}
		}
	},
	computed: {
		premiumUpgradeCreated() {
			return store.getters.getPremiumUpgradeCreated
		},
		filteredCountries() {
			return this.countries.filter(country => country.value !== "MY");
		},
		calculateNetWorth() {
			if (this.form.inv_annual_income != '' && this.form.inv_total_liquid_assets != '' && 
			this.form.inv_other_assets_amount != '' && this.form.inv_total_liabilities_amount != '')
			{
				let total = this.getAverageNumber(this.form.inv_annual_income) 
					+ this.getAverageNumber(this.form.inv_total_liquid_assets) 
					+ this.getAverageNumber(this.form.inv_other_assets_amount)
					- this.getAverageNumber(this.form.inv_total_liabilities_amount);

				this.form.inv_net_worth = this.getNetWorthRange(total)
				return this.getNetWorthRange(total)
			}
		},
		automateSophisticatedInvestor() {
			let annual_income = this.getMaxNumber(this.form.inv_annual_income);
			let liqiud_assets = this.getMaxNumber(this.form.inv_total_liquid_assets);
			let other_assets = this.getMaxNumber(this.form.inv_other_assets_amount);
			let net_worth = this.getMaxNumber(this.form.inv_net_worth);
			
			return (annual_income > 300000)
				|| (liqiud_assets + other_assets > 1000000)
				|| (net_worth > 3000000) ? 1 : 0;
		},
	},
	methods: {
		submit() {
			if(!this.validateForm()) {
				return false
			}
	
			this.loading = true

			UserService.postInvestorUpgradeToPremium(this.form)
			.then(res => {
				this.loading = false;
				if(res.data.success) {
					this.$noty.success('Thank you, your application has been submitted.')
					this.$store.dispatch('updateInvestorPremiumUpgrade', res.data.premium_upgrade_requested_at)
				} else {
					this.$noty.error('Unable to apply, try again later.');
				}
			}).catch(err => {
				this.loading  = false;

				if (typeof err.response != 'undefined' && err.response.status === 422) {
					Object.keys(this.errors).forEach((key,index) => {
					if (typeof err.response.data[key] !== 'undefined') {
						this.errors[key] = err.response.data[key];
						this.$noty.error('Form error found, ' + err.response.data[key]);
					}
					});
				} else {
					this.$noty.error('Sorry, something went wrong and we are unable to process your application. ' +
					'Please try again later or contact us at contact@capsphere.com.my');
				}
			})
	
		},
		disableNegativeOnChange(field_name) {
			if (this.form[field_name] < 0) {
			this.form[field_name] = -this.form[field_name];
			}
		},
		incomeSlipFileChange (e) {
			if (e.target.files.length > 0) {
				Object.keys(e.target.files).forEach((index) => {
					if (this.validateFile('income_slip_file_input', e.target.files[index])) { // validate front ic
						this.form.inv_income_slip.push(e.target.files[index]);
					} else {
						this.$refs['income_slip_file_input'].value = null;
						this.form.inv_income_slip = null;
						return false;
					}
				});
			}
		},
		personalAssetsFileChange (e) {
			if (e.target.files.length > 0) {
				Object.keys(e.target.files).forEach((index) => {
					if (this.validateFile('personal_assets_file_input', e.target.files[index])) { // validate front ic
						this.form.inv_personal_assets.push(e.target.files[index]);
					} else {
						this.$refs['personal_assets_file_input'].value = null;
						this.form.inv_personal_assets = null;
						return false;
					}
				});
			}
		},
		additionalDocumentsFileChange (e) {
			if (e.target.files.length > 0) {
				Object.keys(e.target.files).forEach((index) => {
					if (this.validateFile('additional_documents_file_input', e.target.files[index])) { // validate front ic
						this.form.inv_additional_documents.push(e.target.files[index]);
					} else {
						this.$refs['additional_documents_file_input'].value = null;
						this.form.inv_additional_documents = null;
						return false;
					}
				});
			}
		},
		validateForm() {

			let allowed = true;
	
			// check this screen fields for any errors
			let fields = [
				'inv_country_tax_resident',
				'inv_non_malaysian_income_tax',
				'inv_annual_income',
				'inv_total_liquid_assets',
				'inv_other_assets_amount',
				'inv_total_liabilities_amount',
				'inv_net_worth',
				'inv_source_of_funds',
				'inv_income_slip',
				'inv_personal_assets',
				'inv_agree_declaration'
			];
			fields.forEach((field) => {
				this.$v.form[field].$touch();
			});
	
			fields.forEach((field) => {
				if (this.$v.form[field].$anyError) {
					allowed = false;
				}
			});

			return allowed;
		},
		getAverageNumber(value) {
			let array = {
				"below_50k": 25000,
				"50k_100k": 75000,
				"100k_250k": 175000,
				"250k_500k": 375000,
				"500k_1m": 750000,
				"1m_3m": 2000000,
				"above_3m": 5000000,
			}
			return array[value] || 0;
		},
		getNetWorthRange(total) {
			let ranges = [
				{ value: "below_50k", max: 50000 },
				{ value: "50k_100k", max: 100000 },
				{ value: "100k_250k", max: 250000 },
				{ value: "250k_500k", max: 500000 },
				{ value: "500k_1m", max: 1000000 },
				{ value: "1m_3m", max: 3000000 },
				{ value: "above_3m", max: Infinity }
			];

			for (let range of ranges) {
				if (total <= range.max) {
					return range.value;
				}
			}
		},
		getMaxNumber(value) {
			let array = {
				"below_50k": 50000,
				"50k_100k": 100000,
				"100k_250k": 250000,
				"250k_500k": 500000,
				"500k_1m": 1000000,
				"1m_3m": 3000000,
				"above_3m": 5000000,
			}
			return array[value] || 0;
		},
	},
	watch: {
		calculateNetWorth(newVal) {
			this.form.inv_net_worth = newVal;
		},
		automateSophisticatedInvestor(newVal) {
			this.form.inv_is_sophisticated_investor = newVal;
		}
	}
}
</script>

<style scoped>

</style>
